import {PlayerReduxState} from "../types";

export default function canRestart(state: PlayerReduxState): boolean {
  return !state.isExternal;
}
